import { Component, ViewChild } from '@angular/core';
import { DxValidationGroupComponent } from 'devextreme-angular';
import { BaseEntity, BaseResponse, BaseState, CredentialsCheckResponse, LoginParams } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { RC } from '@core/framework/resources.service';
import { SysGlobals } from '@core/framework/sysglobals';
import { EnumSystemOptions } from '@core/framework/systemoptions.enum';
import { LoginEndpoint } from '@core/endpoints/login.endpoint';
import { EnumCheckCredentialsResult, EnumLoginSecureKeyTypes } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    UserName: string
    OldPassword: string
    NewPassword1: string
    NewPassword2: string
    ShowPasswordRecoveryLink: boolean;
    Stage: number;
    MFACode: string;
    AdditionalTitle: string;
}
@Component({
    providers: ServiceBagServices,
    selector: 'm4u-passwordchangeexpired',
    templateUrl: './passwordchangeexpired.component.html',
    styleUrls: ['./passwordchangeexpired.component.scss']
})
export class PasswordChangeExpiredComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('validationGroup') protected validationGroup: DxValidationGroupComponent;

    constructor(A: ServiceBagService, private loginEndpoint: LoginEndpoint) {
        super(A, 'ChangePasswordExpiredComponent', LoginParams, State);
        this.BindHandler('IsPasswordsMatch');
        this.BindHandler('IsPasswordComplex');
    }

    //Set initial username
    override OnInitState() {
        this.State.UserName = this.QueryParams.UserName;
        this.State.ShowPasswordRecoveryLink = this.SystemOptionFlag(EnumSystemOptions.IsSupportedPasswordRecovery);
    }

    protected override OnInitComponent(): void {
        this.State.Stage = 1;
        this.State.AdditionalTitle = this.RC('titleChangePassword');
    }

    //Make the change. 
    //After making the change,  show the login screen
    //Also, reset the stored password
    //This procedure is done since the session has expired on the server because of the change, and we need a new one
    OnSubmit() {
        if (!this.validationGroup.instance.validate().isValid) return;
        var params = new LoginParams();
        params.Language = SysGlobals.Language;
        params.UserName = this.State.UserName;

        if (this.State.Stage === 1) {
            params.SecureKey = this.State.OldPassword;
            params.NewPassword = this.State.NewPassword1;
        } else {
            params.SecureKey = this.State.MFACode;
            params.SecureKeyType = EnumLoginSecureKeyTypes.MFACode;
            params.Password = this.State.OldPassword;
            params.NewPassword = this.State.NewPassword1;
        }

        this.loginEndpoint.ChangePasswordExpired(params).subscribe((response: CredentialsCheckResponse | BaseResponse) => {
            if (response instanceof BaseResponse) {
                if (!response.IsSuccess) this.UI.StopMessage(response.ResponseMessage);
                this.GoToLogin();
                return;
            }
            switch (response.CheckResult) {
                case EnumCheckCredentialsResult.Success:
                    this.UI.InfoMessage(RC("titlePasswordChanged"));
                    this.GoToLogin();
                    return;
                case EnumCheckCredentialsResult.MFAEmailSent:
                    this.State.Stage = 2;
                    this.State.AdditionalTitle = this.RC('titleMFACodeOnEmailSent');
                    return;
                case EnumCheckCredentialsResult.MFASMSSent:
                    this.State.Stage = 2;
                    this.State.AdditionalTitle = this.RC('titleMFACodeOnPhoneSent');
                    return;
                default:
                    this.UI.StopMessage(response.CheckResultMessage);
                    this.GoToLogin();
                    return;
            }
        });
    }

    OnCancel() {
        this.GoToLogin();
    }

    GoToLogin() {
        this.A.Session.EndSession(() => { this.Navigate(['/system/login'], { Language: SysGlobals.Language, UserName: this.State.UserName }); });
    }

    IsPasswordsMatch(): boolean {
        return this.State.NewPassword1 == this.State.NewPassword2;
    }

    //Verifies (server-side) whether password is complex enough
    IsPasswordComplex() {
        return new Promise((resolve, reject) => {
            var params = new LoginParams;
            params.SecureKey = this.State.NewPassword1;
            params.Language = SysGlobals.Language;
            this.Do(this.loginEndpoint.VerifyPasswordComplexity(params), false, () => resolve(true), (response: BaseResponse) => reject(response.ResponseMessage));
        });
    }

    OnForgotPassword() {
        this.Navigate(['/system/passwordrecovery']);
    }
}
